//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import referalsProfitConfig from './referalsProfitConfig';

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  name: 'referalsProfitModal',
  data() {
    return {
      referalsProfitConfig,
    };
  },
};

